import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: 'industry-card-list',
  template: `
<dynamic-heading title="Industry Applications" level="h4" />
<div class="applications-container mobile-scroll-container">
    <div class="application-card mobile-scroll-item" *ngFor="let industry of industries">
        <img [src]="industry.imagePath" [alt]="industry.title" class="card-image">
        <div class="card-content">
            <dynamic-heading [title]="industry.title" level="h6" textColor="text-secondary-color" />
            <p class="card-description">{{industry.description}}</p>
        </div>
    </div>
</div>
  `,
  styles: [`
        .applications-container {
            /* Mobile styles handled by .mobile-scroll-container global class */
            margin-top: 1.5rem;
        }

        /* Ensure desktop grid overrides if not fully handled by global class (it is, but let's be safe or cleaning up) */
        /* Actually global class handles desktop grid too. So we can just remove the grid props here. */

        .application-card {
            background-color: var(--surface-color);
            border-radius: 1rem;
            overflow: hidden;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            display: flex;
            flex-direction: column;
            border: 1px solid var(--grey-color);
            /* Reset width for mobile scroll item to be controlled by utility */
            width: auto;
        }

        .application-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
        }

        .card-image {
            width: 100%;
            height: 200px;
            object-fit: cover;
            transition: transform 0.5s ease;
        }

        .application-card:hover .card-image {
            transform: scale(1.05);
        }

        .card-content {
            padding: 1.5rem;
            text-align: center;
            flex-grow: 1;
            display: flex;
            flex-direction: column;
        }

        .card-description {
            font-size: 1rem;
            color: var(--text-light);
            line-height: 1.6;
            margin-top: 0.5rem;
        }

        @media (max-width: 768px) {
            .applications-container {
                grid-template-columns: 1fr;
            }
        }
  `]
})

export class IndustryCardComponent implements OnInit {
  @Input() title: string = '';
@Input() industries: any[] = [];

  constructor() { }

  ngOnInit() {

  }
}
